import React, { useEffect, useState, useRef } from 'react';
import { useGLTF, Text, Line, Cone } from '@react-three/drei';
import { useParams } from 'react-router-dom';
import './FrenchBalcony.css';

function FrenchBalcony(props) {
  let para = useParams();
  let [colorr, setcolorr] = useState(null);
  useEffect(() => {
    if (props.colorr == 'brano') {
      setcolorr('#D0D5D9');
    }
    if (props.colorr == 'gray') {
      setcolorr('#f2f3f4');
    }
  }, [props.colorr]);
  function RenderBaseClamps() {
    const group = useRef();
    const { nodes, materials } = useGLTF('/JulietBalconyModel.gltf');
    let windowwidthvar = parseInt(props.windowwidth);

    if (para.count == 'en-us' || para.count == 'es-us') {
      windowwidthvar = windowwidthvar * 25.4;
    }
    let windowamount = parseInt(props.windowamount);
    let oneortwowindows = true;

    if (windowamount == 1) {
      oneortwowindows = false;
    }
    let windowamountarr = [];
    for (let i = 0; i < windowamount; i++) {
      windowamountarr.push(i);
    }
    //0.9/1800 = 0.0005
    let factory = 0.0005;
    let diff = 2300 - parseInt(windowwidthvar);
    let windowadjust = diff * factory;
    let wallscaler = 1 - windowwidthvar / 2300;
    let lengthscaler = 4.2 - 0.001 * (4400 - windowwidthvar);
    let lengthscaler2 = 4.2 - 0.001 * (4400 - windowwidthvar);
    return (
      <>
        <group ref={group} {...props} position={[8, 0, 0]} dispose={null} scale={[10, 10, 10]}>
          {/*Wand */}
          <mesh
            material={materials.WandNeu}
            geometry={nodes.WandLinks.geometry}
            scale={[1, 1, 1]}
            position={[-1.3 + windowadjust, 0, 0 + 0.1]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials.WandNeu}
            geometry={nodes.WandRechts.geometry}
            scale={[1, 1, 1]}
            position={[1.3 - windowadjust, 0, 0 + 0.1]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials.WandNeu}
            geometry={nodes.WandUnten.geometry}
            scale={[1, 1, 1 - wallscaler]}
            position={[0, -1.25, 0 + 0.1]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials.WandNeu}
            geometry={nodes.WandOben.geometry}
            scale={[1, 1, 1 - wallscaler]}
            position={[0, 1.25, 0 + 0.1]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          {/*Window -left*/}
          <mesh
            material={materials['Glass Frosted']}
            visible={false}
            geometry={nodes.GlasL1.geometry}
            position={[0.55, 0, 0.02]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHsenkrecht21.geometry}
            position={[0.08, 0, 0.04]}
            visible={oneortwowindows}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHsenkrecht11.geometry}
            position={[1.03 - windowadjust, 0, 0.04]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHwaagerecht21.geometry}
            scale={[1, 1, lengthscaler]}
            position={[0, -0.97, 0.04]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHwaagerecht11.geometry}
            scale={[1, 1, lengthscaler]}
            position={[0, 0.97, 0.04]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVsenkrecht21.geometry}
            position={[0.08, 0, 0]}
            visible={oneortwowindows}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVsenkrecht11.geometry}
            position={[1.03 - windowadjust, 0, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVwaagerecht21.geometry}
            scale={[1, 1, lengthscaler]}
            position={[0, -0.97, 0]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVwaagerecht11.geometry}
            scale={[1, 1, lengthscaler]}
            position={[0, 0.97, 0]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['Glass Frosted']}
            visible={true}
            scale={[lengthscaler2, 1, 1]}
            geometry={nodes.GlasL.geometry}
            position={[0, 0, 0.02]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHsenkrecht2.geometry}
            position={[-1.03 + windowadjust, 0, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterHsenkrecht1.geometry}
            position={[-0.08, 0, 0.04]}
            visible={oneortwowindows}
            rotation={[-Math.PI / 2, 0, 0]}
          />

          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVsenkrecht2.geometry}
            position={[-1.03 + windowadjust, 0, 0.04]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.FensterVsenkrecht1.geometry}
            position={[-0.08, 0, 0]}
            visible={oneortwowindows}
            rotation={[-Math.PI / 2, 0, 0]}
          />

          {/*Rahmen*/}
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenWaagerecht4.geometry}
            position={[0, -1.05, 0]}
            scale={[1, 1, lengthscaler2]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenWaagerecht3.geometry}
            position={[0, 1.05, 0]}
            scale={[1, 1, lengthscaler2]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          {/*Rahmen
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenWaagerecht2.geometry}
            position={[-0.55, -1.05, 0]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenWaagerecht1.geometry}
            position={[-0.55, 1.05, 0]}
            rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
          />*/}

          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenSenkrecht3.geometry}
            position={[1.1 - windowadjust, 0, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenSenkrecht2.geometry}
            position={[-1.1 + windowadjust, 0, 0]}
            rotation={[-Math.PI / 2, 0, 0]}
          />
          <mesh
            material={materials['AluNeuPhysicalEngine (Rahmen)']}
            geometry={nodes.RahmenSenkrecht1.geometry}
            position={[0, 0, 0]}
            visible={oneortwowindows}
            rotation={[-Math.PI / 2, 0, 0]}
          />
        </group>
      </>
    );
  }

  function RenderViewModel() {
    const group = useRef();
    const { nodes, materials } = useGLTF('/EasyView.gltf');
    //scalinfactor linearFunc -- 2100 == +0.03 ;;;; 600 == -0.07  ergo 0.1/1500 = 0.00006667

    let onFrame = 0;
    let windowwidthvar = props.windowwidth;

    if (para.count == 'en-us' || para.count == 'es-us') {
      windowwidthvar = windowwidthvar * 25.4;
    }
    let insetcontrol = props.windowinset / 100;

    if (props.fenstermontage == 'Inset') {
      insetcontrol = 0.05;
      onFrame = 0.09;
    }
    let pfostenmove = 1.19 - 0.0005 * (2300 - windowwidthvar) - onFrame + 0.01;
    //2100 - 0.01 && 500:: -0.05  ===> 0.06/ 1600 = 0.0000375

    //4400 == 2 ;; 500 == 0.23 ergo 1.77/3900 = 0.000453846
    let windowscale = 2 - 0.000453846 * (4400 - windowwidthvar) - insetcontrol;

    return (
      <>
        <group ref={group} {...props} dispose={null} position={[8, 0, 0 - insetcontrol]} scale={[10, 10, 10]}>
          <group position={[0, -1.12, 0.04 + 0.02]} rotation={[0, 1.57, 0]}>
            <group position={[0.13, 0, 0]} scale={[1, 1, windowscale]}>
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6 + 0.55, 0]}
                scale={[2.5, 0.007, 1]}
                visible={props.handlaufmat == 'edgep'}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ1.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
              <mesh
                material={materials['Glass Frosted']}
                geometry={nodes.GlassJ2.geometry}
                position={[0, 0.6, 0]}
                rotation={[0, 0, 0]}
              />
            </group>
            <group position={[0.13, 0.05, -pfostenmove]} rotation={[-Math.PI / 2, 0, 0]}>
              <mesh material={materials['physi alu bright']} geometry={nodes.ProfileL.geometry} />
              <mesh material={materials.Dichtung} geometry={nodes.DichtungL.geometry} />
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes.DeckelLinksUnten.geometry}
                material-color={colorr}
                position={[0, 0, -0.01]}
              />
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes.DeckelLinksOben.geometry}
                position={[0, 0, 1.11 - 0.003]}
              />
            </group>
            <group position={[0.13, 1.15, pfostenmove]} rotation={[Math.PI / 2, 0, 0]}>
              <mesh material={materials['physi alu bright']} geometry={nodes.ProfileR.geometry} />
              <mesh material={materials.Dichtung} geometry={nodes.DichtungR.geometry} />
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes.DeckelRechtsOben.geometry}
                position={[0, 0, -0.01 + 0.003]}
              />
              <mesh
                material={materials['physi alu bright']}
                geometry={nodes.DeckelRechtsUnten.geometry}
                position={[0, 0, 1.11]}
              />
            </group>
          </group>
        </group>
      </>
    );
  }

  function RenderMeasures() {
    let textscale = [1, 1, 1];
    /*Linearization 2300/0 to 900/0.85 */
    let windowwidthvar = parseFloat(props.windowwidth);
    if (para.count == 'en-us' || para.count == 'es-us') {
      windowwidthvar = windowwidthvar * 25.4;
    }
    //500=8.82;;4400=-10.7 ergo 19.52/3900 = 0.0050128
    let pointadjust = -10.7 + 0.0050128 * (4400 - windowwidthvar);
    return (
      <>
        <group position={[8, 0, 0]}>
          <Line
            points={[
              [-11.3 + pointadjust, 2, -0.8],
              [11.3 - pointadjust, 2, -0.8],
            ]}
            dashed={false}
          />
          <Cone
            position={[11.3 - pointadjust - 0.175, 2, -0.8]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={-Math.PI / 2}
          />
          <Cone
            position={[-11.3 + pointadjust + 0.175, 2, -0.8]}
            scale={[0.1, 0.4, 0.1]}
            material-color={'black'}
            rotation-z={Math.PI / 2}
          />
          <Text color={'black'} position={[0, 3, -1.5]} rotation-y={props.polarcoord} scale={textscale}>
            {para.count == 'en-us' || para.count == 'es-us'
              ? parseFloat(props.windowwidth).toFixed(2) + ' "'
              : parseInt(props.windowwidth) + ' mm'}
          </Text>
        </group>
        {/*<Line points={[[0,11.9 ,props.len1/100 +1.7],[0,0,props.len1/100 +1.7]]} dashed={false}/>
          <Line points={[[0,0,props.len1/100 +0.8],[0,0,props.len1/100 +2.2]]} dashed={false}/>*/}
      </>
    );
  }

  function RenderModelChestrail() {
    const group = useRef();
    const { nodes, materials } = useGLTF('/Chestrail.gltf');
    //scalinfactor linearFunc -- 2100 == +0.03 ;;;; 600 == -0.07  ergo 0.1/1500 = 0.00006667

    let insetcontrol = props.windowinset / 100;
    let insetfactorrail = 0;
    if (props.fenstermontage == 'Inset') {
      insetcontrol = 0;
      insetfactorrail = 0.07;
    }
    //2100 - 0 && 500:: -0.12  ===> -0.12/ 1600 = -0.000075

    //2.205 == 4400 // 0.255 == 500 ergo 1.95/3900 = 0.0005
    let clampscale = 2.205 - 0.0005 * (4400 - props.windowwidth) - insetfactorrail;
    // 2 == 4400 //500==0.23 ergo 1.77/3900 = 0.000453846
    let pipescale = 2 - 0.000453846 * (4400 - props.windowwidth) - insetfactorrail;
    return (
      <>
        <group ref={group} {...props} dispose={null} scale={[10, 10, 10]} position={[8, 0, 0]}>
          <group position={[0, 0, 0.1]}>
            <group position={[-clampscale, 0.04, -0.17 - insetcontrol / 10]} rotation={[-Math.PI / 2, -Math.PI / 2, 0]}>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.VerbinderRechts_1.geometry} />
            </group>
            <group position={[clampscale, 0.04, -0.17 - insetcontrol / 10]} rotation={[-Math.PI / 2, Math.PI / 2, 0]}>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.VerbinderLinks_1.geometry} />
            </group>
            <mesh
              scale={[1, pipescale, 1]}
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.Rohr.geometry}
              position={[0, 0.04, -0.2 - insetcontrol / 10]}
              rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
            />
          </group>
        </group>
      </>
    );
  }

  function RenderModelmod6507() {
    let windowwidthvar = parseFloat(props.windowwidth);
    if (para.count == 'en-us' || para.count == 'es-us') {
      windowwidthvar = windowwidthvar * 25.4;
    }
    // + 0.15 -0.31 // 1 -2
    let onFrame = 0;
    let railadjust = 0;
    let generalinset = 0.95;
    let finetuneouter = 0;
    if (props.fenstermontage == 'Inset') {
      onFrame = 0.08;
      railadjust = 0.06;
      generalinset = 1;
    } else {
      finetuneouter = -0.035;
    }
    //4400==1.828 //500==0.21 ergo 1.618/3900 = 0.000415384
    let glassscale = 1.828 - 0.000415384 * (4400 - windowwidthvar) - onFrame;

    //4400 == 1.789 // 500 == 0.209 ergo 1.58/3900 = 0.000405128
    let raildiff = 1.789 - 0.000405128 * (4400 - windowwidthvar) - railadjust + 0.03;

    //4400 == 2.205 // 500 == 0.255 ergo 1.95/3900 = 0.0005
    let scalerleft = 2.205 - 0.0005 * (4400 - windowwidthvar) - onFrame - finetuneouter;

    const group = useRef();
    const { nodes, materials } = useGLTF('/Mod6507.gltf');
    return (
      <group ref={group} {...props} dispose={null} position={[8, 0, generalinset]} scale={[10, 10, 10]}>
        <group position={[0, 0.03, -0.2]} rotation={[0, -1.57, 0]}>
          <group scale={[1, 1, glassscale]} position={[0, -1.15, 0]} rotation={[-Math.PI, 0, -Math.PI]}>
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ1.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ2.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ1.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ2.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ1.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
            <mesh
              material={materials['Glass Frosted']}
              geometry={nodes.GlassJ2.geometry}
              position={[0, 0.6, 0]}
              rotation={[0, 0, 0]}
            />
          </group>
          <group position={[0.01, 0, 0]}>
            <group position={[0.01, 0, -scalerleft]} rotation={[-Math.PI, 0, Math.PI / 2]}>
              <mesh
                material-color={colorr}
                material={materials.AluAltPhysicalEngine}
                geometry={nodes.VerbinderObenRechts_1.geometry}
              />
            </group>
            <group position={[0.01, 0, scalerleft]} rotation={[0, 0, Math.PI / 2]}>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.VerbinderObenLinks_1.geometry} />
            </group>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.StangeOben.geometry}
              position={[-0.01, 0, 0]}
              scale={[1, 1, raildiff]}
            />
            <mesh
              material={materials.Dichtung}
              geometry={nodes.DichtungOben.geometry}
              position={[-0.01, 0, 0]}
              scale={[1, 1, raildiff]}
            />
          </group>
          <group position={[0.01, -1.1, 0]} rotation={[-Math.PI, 0, 0]}>
            <group position={[0.01, 0, -scalerleft]} rotation={[-Math.PI, 0, Math.PI / 2]}>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.VerbinderUntenLinks_1.geometry} />
            </group>
            <group position={[0.01, 0, scalerleft]} rotation={[0, 0, Math.PI / 2]}>
              <mesh material={materials.AluAltPhysicalEngine} geometry={nodes.VerbinderUntenRechts_1.geometry} />
            </group>
            <mesh
              material={materials.AluAltPhysicalEngine}
              geometry={nodes.StangeUnten.geometry}
              position={[-0.01, 0, 0]}
              rotation={[0, 0, 0]}
              scale={[1, 1, raildiff]}
            />
            <mesh
              material={materials.Dichtung}
              geometry={nodes.DichtungUnten.geometry}
              position={[-0.01, 0, 0]}
              rotation={[0, 0, 0]}
              scale={[1, 1, raildiff]}
            />
          </group>
        </group>
      </group>
    );
  }

  return (
    <>
      {RenderBaseClamps()}
      <>{props.fbsystem == 'EasyGlassView' && <>{RenderViewModel()}</>}</>
      <>{props.fbsystem == 'Chestrail' && <>{RenderModelChestrail()}</>}</>
      <>{props.fbsystem == 'Mod6507' && <>{RenderModelmod6507()}</>}</>
      {RenderMeasures()}
    </>
  );
}

export default FrenchBalcony;
